/*
 * Peak Promise -> order confirmation hand-off. assets/pmg-cart-promise.js
 *
 * What the Peak Promise card promised -- the state and the date -- rides into
 * the cart as hidden line-item properties, so the order confirmation email
 * can print the same promise the customer bought on. (The email is rendered
 * by Shopify the instant the order lands; it cannot ask the app anything.)
 *
 *   _pmg_state     backorder | incoming | supplier
 *   _pmg_eta       YYYY-MM-DD, when it is due to arrive with us
 *   _pmg_dispatch  YYYY-MM-DD, when we expect to send it
 *
 * Leading underscores keep them out of the cart, checkout and the customer's
 * order page; staff still see them on the order in admin.
 *
 * Kept OUT of assets/pmg-availability.js on purpose: that file belongs to the
 * Peak Promise session. This wraps the card's own render() and applyLocal()
 * from outside, so nothing here can change what the card shows -- it only
 * copies what the card already decided. If the card is missing or renamed,
 * this does nothing at all.
 *
 * Loaded from snippets/back-order-button-text.liquid (product pages).
 */
(function () {
  "use strict";
  if (window.__pmgCartPromise) return;
  window.__pmgCartPromise = true;
  if (!window.customElements) return;

  var KEYS = ["_pmg_state", "_pmg_eta", "_pmg_dispatch"];
  var DATE = /^\d{4}-\d{2}-\d{2}/;

  function stamp(card, data) {
    var form = card.closest("form[action*='/cart/add']") ||
      document.querySelector("form[action*='/cart/add']");
    if (!form || !data) return;
    var vals = {};
    // Only "not on a shelf today" states. Anything else clears the stamp, so
    // moving from a backordered size to one we have never carries the wrong
    // promise into the order.
    if (data.state === "backorder" || data.state === "incoming" || data.state === "supplier") {
      vals._pmg_state = data.state;
      var eta = (data.incoming && data.incoming.eta) || (data.supply && data.supply.eta) || "";
      if (DATE.test(eta)) vals._pmg_eta = String(eta).slice(0, 10);
      var dispatch = (data.dispatch && data.dispatch.date) || "";
      if (DATE.test(dispatch)) vals._pmg_dispatch = String(dispatch).slice(0, 10);
    }
    KEYS.forEach(function (key) {
      var name = "properties[" + key + "]";
      var input = form.querySelector("input[name='" + name + "'][data-pmg-stamp]");
      if (vals[key]) {
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.setAttribute("data-pmg-stamp", "");
          form.appendChild(input);
        }
        input.value = vals[key];
      } else if (input && input.parentNode) {
        input.parentNode.removeChild(input);
      }
    });
  }

  function patch(Card) {
    if (!Card || Card.prototype.__pmgStamp) return;
    Card.prototype.__pmgStamp = true;

    // The app's answer: has the dates.
    var render = Card.prototype.render;
    if (typeof render === "function") {
      Card.prototype.render = function (data) {
        var out = render.apply(this, arguments);
        try { stamp(this, data); } catch (e) { /* never break the card */ }
        return out;
      };
    }
    // The instant answer from Liquid's variant map on a size change: state
    // only, which is still right until the app's answer lands a moment later.
    var applyLocal = Card.prototype.applyLocal;
    if (typeof applyLocal === "function") {
      Card.prototype.applyLocal = function (variantId) {
        var out = applyLocal.apply(this, arguments);
        try {
          var row = this.variants && this.variants[String(variantId)];
          if (row) stamp(this, { state: row.s });
        } catch (e) { /* never break the card */ }
        return out;
      };
    }
  }

  // A card that already answered before this script arrived is stamped from
  // the answer it is holding, rather than waiting for the next size change.
  function catchUp() {
    Array.prototype.forEach.call(document.querySelectorAll("pmg-availability"), function (card) {
      try {
        var data = card.cache && card.cache[card.dataset.variant + "|" + (card.postcode || "")];
        if (data) stamp(card, data);
      } catch (e) { /* never break the card */ }
    });
  }

  var existing = window.customElements.get("pmg-availability");
  if (existing) {
    patch(existing);
    catchUp();
  } else {
    window.customElements.whenDefined("pmg-availability").then(function () {
      patch(window.customElements.get("pmg-availability"));
      catchUp();
    });
  }
})();
